import React from "react";
import backgroundImage from "../images/AmarAkbarAnthony/tableBg.webp";
import newRoundImg from "../images/AmarAkbarAnthony/New_Round.svg";
import welcome from "../images/AmarAkbarAnthony/welcome.gif";
import ideal from "../images/AmarAkbarAnthony/idle.gif";
import clapping from "../images/AmarAkbarAnthony/clapping.gif";
import crown from "../images/AmarAkbarAnthony/crown.png";
import closedCard from "../images/AmarAkbarAnthony/closed-card.jpg";
import { cards } from "../images";
import styles from "./styles.module.css";
import GameAreaLoader from "../../Loader/GameAreaLoader";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import useRoundLoader from "../../../api/useRoundLoader";

export default function AAAGame({ bettingClosed, animationTime, socketData, remainingTime }) {

const roundId = socketData?.roundId;
const settlement = socketData?.settlement;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlement, 5000);

  const isIdle = settlement?.idle === true;
  const isClapping = settlement?.clapping === true;

  const currentGif = !bettingClosed
    ? welcome
    : isClapping
    ? clapping
    : isIdle
    ? ideal
    : welcome;

  const mapDrawnCardToKey = (drawnCard) => {
    if (!drawnCard || typeof drawnCard !== 'string') return null;
    const raw = drawnCard.trim().toUpperCase().replace(/\.(WEBP|PNG|JPE?G|SVG)$/i, '');
    if (cards[raw]) return cards[raw];
    if (cards[`${raw}.webp`]) return cards[`${raw}.webp`];

    const parts = raw.split(/\s+/);
    if (parts.length >= 2) {
      const rank = parts[0];
      const suit = parts[1];
      const suitCode = suit.startsWith('SPADE') ? 'SS' : suit.startsWith('HEART') ? 'HH' : suit.startsWith('DIAM') ? 'DD' : suit.startsWith('CLUB') ? 'CC' : null;
      if (!suitCode) return null;
      const normalizedRank = rank === 'ACE' ? 'A' : rank === 'KING' ? 'K' : rank === 'QUEEN' ? 'Q' : rank === 'JACK' ? 'J' : rank;
      const key = `${normalizedRank}${suitCode}`;
      return cards[key] || cards[`${key}.webp`] || null;
    }
    return null;
  };

  
  const settledDrawnCard = mapDrawnCardToKey(settlement?.drawnCard);

  const winningBetsString = settlement?.outcome || '';
  const winnerFromSocket = (() => {
    const upper = String(winningBetsString).toUpperCase();
    if (upper.includes('ANTHONY')) return 'ANTHONY';
    if (upper.includes('AKBAR')) return 'AKBAR';
    if (upper.includes('AMAR')) return 'AMAR';
    return null;
  })();
  console.log('RAW drawnCard:', JSON.stringify(settlement?.drawnCard));
console.log('MAPPED result:', settledDrawnCard);
console.log('Available card keys:', Object.keys(cards));

  return (
       <GameAreaLoader showLoader={gameScreenLoader}>
    <div className={styles.gameContainer}>
      <div className={styles.gameArea}>
        <div className={styles.gameBackground} style={{ aspectRatio: "2/1" }}>
          <img
            src={backgroundImage}
            alt="Game Table Background"
            className={styles.backgroundImage}
            draggable={false}
          />
        {/* {!bettingClosed && remainingTime <= 30 && remainingTime >= 27 && (
  <div className={styles.newRoundOverlay}>
    <div className={styles.newRoundBackground}>
      <img
        src={newRoundImg}
        alt="New Round"
        className={styles.newRoundImage}
        draggable={false}
      />
    </div>
  </div>
)} */}
          {/* Gif for current stage */}
        <div className={styles.stageGifContainer} style={{ height: "50%" }}>
  <img
    src={currentGif}
    alt="dealer gif"
    className={styles.stageGifImage}
    draggable={false}
    style={{ objectFit: "contain", zIndex: 10 }}
  />
</div>
          {/* Cards area (bottom 50%) */}
          <div
            className={styles.cardsContainer}
            style={{ top: "50%", height: "50%" }}
          >
            {/* Name and Rank List */}
            <div className={styles.nameRankSection}>
              <div className={styles.nameRankList}>
                <div className={styles.nameRankItem}>
                  <span className={styles.playerName}>AMAR</span>
                  <span className={styles.playerRank}>A23456</span>
                </div>
                <div className={styles.nameRankItem}>
                  <span className={styles.playerName}>AKBAR</span>
                  <span className={styles.playerRank}>78910</span>
                </div>
                <div className={styles.nameRankItem}>
                  <span className={styles.playerName}>ANTHONY</span>
                  <span className={styles.playerRank}>JQK</span>
                </div>
              </div>
            </div>

            <div className={styles.cardDisplaySection}>

           {!bettingClosed && (
  <img src={closedCard} alt="Closed Card" className={styles.cardImage} draggable={false} />
)}

{bettingClosed && !isIdle && !isClapping && (
  <img src={closedCard} alt="Closed Card" className={styles.cardImage} draggable={false} />
)}

{bettingClosed && isIdle && (
  settledDrawnCard
    ? <img src={settledDrawnCard} alt="Drawn Card" className={styles.cardImage} draggable={false} />
    : <img src={closedCard} alt="Closed Card" className={styles.cardImage} draggable={false} />
)}  

{bettingClosed && isClapping && (
  settledDrawnCard
    ? <img key={settledDrawnCard} src={settledDrawnCard} alt="Drawn Card" className={styles.cardImage} draggable={false} />
    : <img src={closedCard} alt="Closed Card" className={styles.cardImage} draggable={false} />
)}         </div>

            {/* Winner (Clapping Stage) */}
       {bettingClosed && isClapping && (
  <div className={styles.winnerContainer}>
    <img src={crown} alt="Winner Crown" className={styles.crownImage} />
    <span className={styles.winnerText}>
      Winner: {winnerFromSocket || ''}
    </span>
  </div>
)}
          </div>
        </div>
      </div>
      {processingLoader && (
  <div className="dataProcessingOverlay">
    <div className="cardSpinner" />
  </div>
)}
    </div>
    </GameAreaLoader>
  );
}